import React from "react";

const WebPages_Classes = () => {
  return (
    <div className="tutorial-page">
      <h1>WebPages Classes</h1>
      <p>This is the WebPages Classes page content.</p>
    </div>
  );
};

export default WebPages_Classes;
